import { render, staticRenderFns } from "./DashboardNonConformity.vue?vue&type=template&id=5001e220&"
import script from "./DashboardNonConformity.vue?vue&type=script&lang=js&"
export * from "./DashboardNonConformity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports